import {ChangeDetectionStrategy, Component, inject, signal} from "@angular/core"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {FilesService} from "@common/services/files/files.service"
import {OnboardingDialogBlenderAddonDownloadGQL} from "@platform/components/dialogs/onboarding-dialog/onboarding-dialog.generated"
import {StartingScreenService} from "@platform/components/dialogs/onboarding-dialog/starting-screen.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-onboarding-dialog",
    templateUrl: "./onboarding-dialog.component.html",
    styleUrl: "./onboarding-dialog.component.scss",
})
export class OnboardingDialogComponent {
    readonly $dontShowAgain = signal(false)
    readonly $blenderAddonDownloadLoading = signal(false)
    readonly $blenderAddonUnavailable = signal(false)

    private readonly startingScreen = inject(StartingScreenService)
    private readonly blenderAddonDownloadGql = inject(OnboardingDialogBlenderAddonDownloadGQL)

    async downloadBlenderAddon(): Promise<void> {
        if (this.$blenderAddonDownloadLoading()) return
        this.$blenderAddonDownloadLoading.set(true)
        try {
            const result = await fetchThrowingErrors(this.blenderAddonDownloadGql)({}).catch(() => null)
            const download = result?.blenderAddonDownload ?? null
            this.$blenderAddonUnavailable.set(!download)
            if (download) FilesService.downloadFile(download.fileName, download.url)
        } finally {
            this.$blenderAddonDownloadLoading.set(false)
        }
    }

    onClose(): void {
        this.startingScreen.close()
    }

    async onHide(): Promise<void> {
        if (this.$dontShowAgain()) {
            await this.startingScreen.dismissForever()
        } else {
            this.startingScreen.close()
        }
    }
}
